import styles from "./BlockActivityCard.module.css"
import React, { useRef } from 'react';
import { useDetailContext } from '../../../context/DetailContext';
import { useTranslation } from "react-i18next";
import { getPrimaryProductImage } from "../../../services/productImageService";
import { usePublicCatalog } from "../../../context/PublicCatalogContext";
import { ActivityCardProps } from "../../../types/activity.types";
import { Users, MapPinned  } from "lucide-react";
import { getPeopleWord } from "../../../utils/people";
import PrimaryButton from "../../Button/PrimaryButton/PrimaryButton";
/**
* Block card for activities items
*
* @param props activitiesItemCardProps
* @param {ActivitiesItem} props.product - Product
* @returns TSX.Element
*/
const BlockActivityCard = ({ product }: ActivityCardProps) => {
    const {isPublicView} = usePublicCatalog();
    const { t, i18n } = useTranslation(); // Translation
    const { openDetail } = useDetailContext(); // Detail context
    const buttonRef = useRef<HTMLDivElement>(null)

    // Handle opening detail
    const handleOpen = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!buttonRef.current?.contains(e.target as Node)) {
            openDetail && openDetail({id: product.id, type: "activities" }); 
        }
    }

    // Wording for recommended amount of people
    const peopleWord = getPeopleWord(i18n.language, product.guest_count ?? product.guest_count ?? 1)

    return(
        <>
            <div className={styles.ProductBlock} key={product.id} onClick={handleOpen}>
                <div className={styles.ProductIImageCenter}>
                    <div className={styles.ProductImage} style={{ backgroundImage: `url(${getPrimaryProductImage(product)})` }}></div>
                </div>
                <div className={styles.ProductContent}>
                    <div className={styles.ProductDescription}>
                        <p>{i18n.language === "en" ? product.title_en || "N/A" : product.title}</p>
                        <p className={styles.ProductCat}>
                            {product.category}
                        </p>
                    </div>

                    <div className={styles.ProductTags}>
                        <div className={styles.ProductTag}>
                            <MapPinned  />
                            <p>{product.enviroment}</p>
                        </div>
                        <div className={styles.ProductTag}>
                            <Users />
                            <p>
                                {product.guest_count || 1}
                                {` ${peopleWord}`}
                            </p>
                        </div>
                    </div>

                </div>
                <div className={styles.CartButtons}>
                        <PrimaryButton 
                        text={t("activities.order_activity")} 
                        disabled={ isPublicView}
                        onClick={handleOpen} 
                        className={styles.CartButton}/>
                    
                </div>
            </div>
        </>
    )
}
export default BlockActivityCard
